import { IBreadcrumbProps, ISearchBoxStyles, SearchBox } from "@fluentui/react";
import { ChangeEvent, CSSProperties, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomerDataGrid from "../components/CustomerSearch/CustomerSearchGridComponent";
import { logPageView } from "../helper/AppInsightsHelper";
import { CustomBreadcrumb } from "../SharedComponents/CustomBreadcrumb";
import { debounce } from "../Utils/js-common";
import { Paper } from "@mui/material";
import { CUSTOMER_SEARCH_STYLES } from "../components/CustomerSearch/CustomerSearch.styles";

const style = {
  searchBoxParent: {
    marginBottom: 18
  } as CSSProperties,
  seachBox: {
    root: {
      width: "60%",
      marginLeft: "20%",
      marginTop: 3,
      borderRadius: 4
    }
  } as Partial<ISearchBoxStyles>
};
const breadcrumbStyles = {
  root: {
    fontSize: "14px",
    margin: 0,
    "--itemLink-color": "rgb(0, 120, 212)"
  },
  item: {
    fontSize: "inherit"
  },
  itemLink: {
    fontSize: "inherit",
    color: "var(--itemLink-color)",
    ":hover": {
      background: "none",
      textDecoration: "underline",
      color: "var(--itemLink-color)"
    }
  }
};

export default function CustomerSearch() {
  const navigate = useNavigate();
  const key = "customer-search-bc";
  const [searchText, setSearchText] = useState("");
  const bcrops: IBreadcrumbProps = {
    items: [
      { text: "Home", key: "home", onClick: () => navigate("/") },
      { text: "Explore Customers", key: "explore-customers", isCurrentItem: true }
    ],
    styles: breadcrumbStyles
  };

  // Search function
  const performSearch = (query: string) => setSearchText(query);

  // Debounced search function
  const debouncedSearch = debounce(performSearch);

  const onChange = (event?: ChangeEvent<HTMLInputElement>) => debouncedSearch(event?.target.value ?? "");

  const onClear = (event?: any) => performSearch(event?.target.value || "");

  useEffect(() => logPageView("Customer Search Page", window.location.href), []);

  return (
    <div className="mainCard" style={{ marginTop: 10, marginRight: 10 }}>
      <CustomBreadcrumb {...bcrops} key={key} />
      <Paper className={CUSTOMER_SEARCH_STYLES.CUSTOMER_SEARCH_DATA_GRID.CLASS_NAMES.GRID_AND_FILTER_PILL_CONTAINER}>
        <div style={style.searchBoxParent}>
          <SearchBox
            disableAnimation
            onChange={onChange}
            onClear={onClear}
            onSearch={performSearch}
            placeholder="Search customer by Tenant Id, Tenant Name, Customer Name or TPID"
            styles={style.seachBox}
          />
        </div>
        <CustomerDataGrid
          searchText={searchText}
        />
      </Paper>
    </div>
  );
}
